import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { connect } from "react-redux";
import AddReceving from "./AddReceving";
import RecevingDetails from "./RecevingDetails";
import ReceivingReport from "./ReceivingReport";
import { isNull } from "lodash";
import ReceivingReportByDate from "./ReceivingReportByDate";

const Receving = (props) => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  return (
    <>
      <Tabs
        defaultActiveKey={
          !isNull(permissions) && permissions.some((p) => p["sub_id"] === 74)
            ? "RecList"
            : !isNull(permissions) &&
              permissions.some((p) => p["sub_id"] === 75)
            ? "AddRec"
            : !isNull(permissions) &&
              permissions.some((p) => p["sub_id"] === 76)
            ? "RecReport"
            : ""
        }
        id="RecList"
        className="mb-3"
        unmountOnExit={true}
      >
        <Tab
          eventKey="RecList"
          title="GRN Detail"
          unmountOnExit={true}
          disabled={
            !isNull(permissions) && permissions.some((p) => p["sub_id"] === 74)
              ? false
              : true
          }
        >
          <RecevingDetails />
        </Tab>
        <Tab
          eventKey="AddRec"
          title="Add GRN"
          unmountOnExit={true}
          disabled={
            !isNull(permissions) && permissions.some((p) => p["sub_id"] === 75)
              ? false
              : true
          }
        >
          <AddReceving />
        </Tab>

        <Tab
          eventKey="RecReport"
          title="GRN Report By Id"
          unmountOnExit={true}
          disabled={
            !isNull(permissions) && permissions.some((p) => p["sub_id"] === 76)
              ? false
              : true
          }
        >
          <ReceivingReport />
        </Tab>
        <Tab
          eventKey="RecReportBYDate"
          title="GRN Report By Date"
          unmountOnExit={true}
          disabled={
            !isNull(permissions) && permissions.some((p) => p["sub_id"] === 76)
              ? false
              : true
          }
        >
          <ReceivingReportByDate />
        </Tab>
      </Tabs>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
const mapStateToProps = (state, ownProps) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Receving);
